import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "beneficiary-page" }
const _hoisted_2 = { class: "beneficiary-sidebar" }
const _hoisted_3 = ["title"]
const _hoisted_4 = { class: "sidebar-title-badge" }
const _hoisted_5 = { class: "sidebar-tabs" }
const _hoisted_6 = { class: "sidebar-summary" }
const _hoisted_7 = { class: "summary-item beneficiary-count" }
const _hoisted_8 = { class: "value" }
const _hoisted_9 = { class: "summary-item active-count" }
const _hoisted_10 = { class: "value" }
const _hoisted_11 = { class: "summary-item caregiver-count" }
const _hoisted_12 = { class: "value" }
const _hoisted_13 = { class: "sidebar-search" }
const _hoisted_14 = { class: "search-header" }
const _hoisted_15 = { class: "search-input-wrapper" }
const _hoisted_16 = { class: "sidebar-period" }
const _hoisted_17 = { class: "period-month-section" }
const _hoisted_18 = { class: "period-month-nav" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = { class: "current-year" }
const _hoisted_21 = { class: "current-month" }
const _hoisted_22 = ["disabled"]
const _hoisted_23 = { class: "beneficiary-main" }
const _hoisted_24 = {
  key: 0,
  class: "beneficiary-list-section"
}
const _hoisted_25 = { class: "section-header" }
const _hoisted_26 = { class: "header-title" }
const _hoisted_27 = { class: "title-icon" }
const _hoisted_28 = { class: "title-count" }
const _hoisted_29 = { class: "header-actions" }
const _hoisted_30 = ["disabled", "title"]
const _hoisted_31 = { class: "current-month-label" }
const _hoisted_32 = {
  key: 0,
  class: "beneficiary-table"
}
const _hoisted_33 = { class: "col-no" }
const _hoisted_34 = { class: "patient-name" }
const _hoisted_35 = { class: "patient-icon" }
const _hoisted_36 = { class: "text-center" }
const _hoisted_37 = { class: "date-text" }
const _hoisted_38 = { class: "text-center" }
const _hoisted_39 = { class: "date-text" }
const _hoisted_40 = { class: "text-center" }
const _hoisted_41 = { class: "service-months" }
const _hoisted_42 = { class: "text-center col-action" }
const _hoisted_43 = ["onClick"]
const _hoisted_44 = { class: "text-center col-action" }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = {
  key: 0,
  class: "detail-row"
}
const _hoisted_47 = { colspan: "8" }
const _hoisted_48 = { class: "inline-detail" }
const _hoisted_49 = {
  key: 0,
  class: "monthly-summary"
}
const _hoisted_50 = { class: "month-header" }
const _hoisted_51 = { class: "month-label" }
const _hoisted_52 = { class: "month-stats" }
const _hoisted_53 = { class: "stat-item" }
const _hoisted_54 = { class: "stat-value" }
const _hoisted_55 = { class: "stat-item" }
const _hoisted_56 = { class: "stat-value" }
const _hoisted_57 = {
  key: 0,
  class: "month-caregivers"
}
const _hoisted_58 = {
  key: 1,
  class: "month-sugas"
}
const _hoisted_59 = {
  key: 1,
  class: "empty-text"
}
const _hoisted_60 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_61 = { class: "empty-icon" }
const _hoisted_62 = {
  key: 1,
  class: "beneficiary-manage-section"
}
const _hoisted_63 = { class: "section-header" }
const _hoisted_64 = { class: "header-title" }
const _hoisted_65 = { class: "title-icon manage" }
const _hoisted_66 = { class: "title-count" }
const _hoisted_67 = { class: "header-actions" }
const _hoisted_68 = ["disabled"]
const _hoisted_69 = {
  key: 0,
  class: "table-wrapper"
}
const _hoisted_70 = { class: "manage-table" }
const _hoisted_71 = { class: "col-no" }
const _hoisted_72 = { class: "patient-name" }
const _hoisted_73 = { class: "patient-icon" }
const _hoisted_74 = { class: "text-center" }
const _hoisted_75 = {
  key: 0,
  class: "date-text"
}
const _hoisted_76 = ["value"]
const _hoisted_77 = { class: "text-center" }
const _hoisted_78 = { key: 0 }
const _hoisted_79 = {
  key: 0,
  class: "grade-badge"
}
const _hoisted_80 = {
  key: 1,
  class: "empty-value"
}
const _hoisted_81 = { class: "text-center" }
const _hoisted_82 = { key: 0 }
const _hoisted_83 = {
  key: 0,
  class: "copay-badge"
}
const _hoisted_84 = {
  key: 1,
  class: "empty-value"
}
const _hoisted_85 = { class: "text-center col-action" }
const _hoisted_86 = ["onClick"]
const _hoisted_87 = ["disabled"]
const _hoisted_88 = {
  key: 1,
  class: "empty-state"
}
const _hoisted_89 = { class: "empty-icon" }

import { ref, computed, onMounted, watch } from 'vue';
import { useStore } from 'vuex';
import axios from 'axios';
import LodingComponent from '@/components/loading/LodingComponent.vue';

// Types
interface Beneficiary {
  patient_code: string;
  patient_name: string;
  first_service_date: string;
  last_service_date: string;
  total_months: number;
}

interface MonthlySummary {
  year_month: string;
  service_days: number;
  caregiver_count: number;
  caregivers: string;
  total_minutes: number;
  suga_types: string;
}

interface BeneficiaryInfo {
  bf_idx: number;
  m_sisul_code: string;
  bf_patient_code: string;
  bf_patient_name: string;
  bf_birth: string | null;
  bf_grade: string | null;
  bf_copay_rate: string | null;
  bf_copay_type: string | null;
  bf_phone: string | null;
  bf_address: string | null;
  bf_start_date: string | null;
  bf_end_date: string | null;
  bf_memo: string | null;
  bf_status: 'active' | 'inactive';
}

interface EditForm {
  patientCode: string;
  patientName: string;
  birth: string;
  grade: string;
  copayRate: string;
  copayType: string;
  phone: string;
  address: string;
  startDate: string;
  endDate: string;
  memo: string;
  status: string;
}

// Store

export default /*@__PURE__*/_defineComponent({
  __name: 'BeneficiaryPage',
  setup(__props) {

const store = useStore();
const sisulCode = computed(() => store.getters.institutionCode);

// State
const isLoading = ref(true);
const isPdfLoading = ref(false);
const isSyncing = ref(false);
const isSaving = ref(false);
const sidebarPosition = ref<'left' | 'right'>('right');
const searchKeyword = ref('');
const activeTab = ref<'schedule' | 'manage'>('manage');

const beneficiaryList = ref<Beneficiary[]>([]);
const periodBeneficiaries = ref<Set<string>>(new Set());
const selectedBeneficiary = ref<Beneficiary | null>(null);

const monthlySummary = ref<MonthlySummary[]>([]);

// 수급자 관리 탭 관련 상태
const beneficiaryInfoList = ref<BeneficiaryInfo[]>([]);
const editingPatientCode = ref<string | null>(null);
const editForm = ref<EditForm>({
  patientCode: '',
  patientName: '',
  birth: '',
  grade: '',
  copayRate: '',
  copayType: '',
  phone: '',
  address: '',
  startDate: '',
  endDate: '',
  memo: '',
  status: 'active'
});

// 현재 년월 (YYYYMM)
const now = new Date();
const currentYear = now.getFullYear();
const currentMonth = now.getMonth() + 1;

// 기간 선택 관련 상태
const periodMode = ref<'all' | 'month'>('month');
const selectedYear = ref(currentYear);
const selectedMonth = ref(currentMonth);

// 선택 가능한 연도 (현재 연도 기준 5년 전부터 현재까지)
const availableYears = computed(() => {
  const years: number[] = [];
  for (let y = currentYear - 5; y <= currentYear; y++) {
    years.push(y);
  }
  return years;
});

// 선택 가능한 월 (1~12월)
const availableMonths = computed(() => {
  return Array.from({ length: 12 }, (_, i) => i + 1);
});

// 다음달 계산
const nextMonthYear = currentMonth === 12 ? currentYear + 1 : currentYear;
const nextMonthMonth = currentMonth === 12 ? 1 : currentMonth + 1;

// 이전/다음 월 이동 가능 여부
const canGoPrev = computed(() => {
  return !(selectedYear.value === currentYear - 5 && selectedMonth.value === 1);
});

const canGoNext = computed(() => {
  // 다음달까지 선택 가능
  return !(selectedYear.value === nextMonthYear && selectedMonth.value === nextMonthMonth);
});

// 선택된 기간 (YYYYMM 형식)
const selectedYM = computed(() => {
  return `${selectedYear.value}${String(selectedMonth.value).padStart(2, '0')}`;
});

// 화면에 표시할 기간 라벨
const displayPeriodLabel = computed(() => {
  if (periodMode.value === 'all') {
    return '전체 기간';
  }
  return `${selectedYear.value}년 ${selectedMonth.value}월`;
});

// Computed
const filteredBeneficiaryList = computed(() => {
  let list = beneficiaryList.value;
  
  // 검색 필터
  if (searchKeyword.value) {
    list = list.filter(b => b.patient_name.includes(searchKeyword.value));
  }
  
  // 기간 필터 (월별 모드일 때만 해당 기간 수급자만 표시)
  if (periodMode.value === 'month') {
    list = list.filter(b => periodBeneficiaries.value.has(b.patient_code));
  }
  
  return list;
});

const activeThisMonth = computed(() => {
  return periodBeneficiaries.value.size;
});

const totalServiceMonths = computed(() => {
  return beneficiaryList.value.reduce((sum, b) => sum + (b.total_months || 0), 0);
});

// 수급자 관리 탭 - 검색 필터 적용
const filteredBeneficiaryInfoList = computed(() => {
  let list = beneficiaryInfoList.value;
  
  if (searchKeyword.value) {
    list = list.filter(b => b.bf_patient_name.includes(searchKeyword.value));
  }
  
  return list;
});

// Methods
const toggleSidebarPosition = () => {
  sidebarPosition.value = sidebarPosition.value === 'left' ? 'right' : 'left';
};

// 기간 모드 설정
const setPeriodMode = (mode: 'all' | 'month') => {
  periodMode.value = mode;
  fetchPeriodBeneficiaries();
};

// 이전 월로 이동
const prevMonth = () => {
  if (!canGoPrev.value) return;
  
  if (selectedMonth.value === 1) {
    selectedYear.value--;
    selectedMonth.value = 12;
  } else {
    selectedMonth.value--;
  }
};

// 다음 월로 이동
const nextMonth = () => {
  if (!canGoNext.value) return;
  
  if (selectedMonth.value === 12) {
    selectedYear.value++;
    selectedMonth.value = 1;
  } else {
    selectedMonth.value++;
  }
};

const formatMinutes = (minutes: number): string => {
  if (!minutes) return '0분';
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  if (hours === 0) return `${mins}분`;
  if (mins === 0) return `${hours}h`;
  return `${hours}h ${mins}m`;
};

const formatYearMonth = (ym: string): string => {
  if (!ym || ym.length !== 6) return ym;
  return `${ym.substring(0, 4)}년 ${parseInt(ym.substring(4))}월`;
};

const formatDateShort = (dateStr: string): string => {
  if (!dateStr) return '-';
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return dateStr;
  return `${date.getFullYear()}.${String(date.getMonth() + 1).padStart(2, '0')}.${String(date.getDate()).padStart(2, '0')}`;
};

const isActiveThisMonth = (beneficiary: Beneficiary): boolean => {
  return periodBeneficiaries.value.has(beneficiary.patient_code);
};

// 전체 수급자 목록 조회
const fetchBeneficiaryList = async () => {
  if (!sisulCode.value) return;
  
  try {
    const response = await axios.get(
      `/api/beneficiary/list/${sisulCode.value}`
    );
    
    if (response.data.success) {
      beneficiaryList.value = response.data.data;
    }
  } catch (error) {
    console.error('수급자 목록 조회 오류:', error);
  }
};

// 선택 기간 수급자 목록 조회
const fetchPeriodBeneficiaries = async () => {
  if (!sisulCode.value) return;
  
  try {
    let url = '';
    
    if (periodMode.value === 'all') {
      // 전체 기간: 모든 수급자가 해당
      periodBeneficiaries.value = new Set(beneficiaryList.value.map(b => b.patient_code));
      return;
    } else {
      // 특정 월: 해당 월의 수급자만 조회
      url = `/api/beneficiary/list/${sisulCode.value}/${selectedYM.value}`;
    }
    
    const response = await axios.get(url);
    
    if (response.data.success) {
      const codes = new Set<string>();
      response.data.data.forEach((b: { patient_code: string }) => {
        codes.add(b.patient_code);
      });
      periodBeneficiaries.value = codes;
    }
  } catch (error) {
    console.error('기간별 수급자 조회 오류:', error);
  }
};

// 수급자 토글 (클릭 시 확장/축소)
const toggleBeneficiary = async (beneficiary: Beneficiary) => {
  // 이미 선택된 수급자를 다시 클릭하면 닫기
  if (selectedBeneficiary.value?.patient_code === beneficiary.patient_code) {
    selectedBeneficiary.value = null;
    return;
  }
  
  selectedBeneficiary.value = beneficiary;
  await fetchMonthlySummary(beneficiary.patient_code);
};

const fetchMonthlySummary = async (patientCode: string) => {
  if (!sisulCode.value) return;
  
  try {
    const response = await axios.get(
      `/api/beneficiary/monthly/${sisulCode.value}/${patientCode}`
    );
    
    if (response.data.success) {
      monthlySummary.value = response.data.data;
    }
  } catch (error) {
    console.error('월별 요약 조회 오류:', error);
    monthlySummary.value = [];
  }
};

// 일정표 PDF 출력
const printSchedulePdf = async (beneficiary: Beneficiary) => {
  if (!sisulCode.value) return;
  
  // 전체 기간 모드인 경우 특정 월 선택 요청
  if (periodMode.value === 'all') {
    alert('일정표 PDF 출력을 위해 특정 월을 선택해주세요.\n\n좌측 사이드바에서 원하는 년/월을 선택한 후 다시 시도해주세요.');
    return;
  }
  
  try {
    const yearMonth = selectedYM.value;
    
    const response = await axios.get(
      `/api/beneficiary/schedule-pdf/${sisulCode.value}/${beneficiary.patient_code}/${yearMonth}`,
      { responseType: 'blob' }
    );
    
    // PDF 다운로드
    const blob = new Blob([response.data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `일정표_${beneficiary.patient_name}_${yearMonth}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('일정표 PDF 출력 오류:', error);
    alert('일정표 PDF 출력에 실패했습니다.');
  }
};

// 전체 수급자 일정표 PDF 일괄 출력
const printAllPatientsPdf = async () => {
  if (!sisulCode.value) return;
  
  // 전체 기간 모드인 경우 특정 월 선택 요청
  if (periodMode.value === 'all') {
    alert('일정표 PDF 출력을 위해 특정 월을 선택해주세요.\n\n사이드바에서 원하는 년/월을 선택한 후 다시 시도해주세요.');
    return;
  }
  
  const patientCount = filteredBeneficiaryList.value.length;
  if (patientCount === 0) {
    alert('출력할 수급자가 없습니다.');
    return;
  }
  
  // 확인 메시지
  if (!confirm(`${selectedYear.value}년 ${selectedMonth.value}월 전체 수급자(${patientCount}명)의 일정표를 PDF로 출력하시겠습니까?\n\n데이터 양에 따라 시간이 소요될 수 있습니다.`)) {
    return;
  }
  
  try {
    isPdfLoading.value = true;
    const yearMonth = selectedYM.value;
    
    const response = await axios.get(
      `/api/beneficiary/all-patients-schedule-pdf/${sisulCode.value}/${yearMonth}`,
      { responseType: 'blob' }
    );
    
    // PDF 다운로드
    const blob = new Blob([response.data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `전체수급자_일정표_${yearMonth}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('전체 수급자 일정표 PDF 출력 오류:', error);
    alert('전체 수급자 일정표 PDF 출력에 실패했습니다.');
  } finally {
    isPdfLoading.value = false;
  }
};

// 수급자 정보 목록 조회
const fetchBeneficiaryInfoList = async () => {
  if (!sisulCode.value) return;
  
  try {
    const response = await axios.get(
      `/api/beneficiary/info/list/${sisulCode.value}`
    );
    
    if (response.data.success) {
      beneficiaryInfoList.value = response.data.data;
    }
  } catch (error) {
    console.error('수급자 정보 목록 조회 오류:', error);
  }
};

// 일정계획에서 수급자 동기화
const syncBeneficiaries = async () => {
  if (!sisulCode.value) return;
  
  if (!confirm('일정계획에 있는 수급자를 수급자 정보 테이블에 동기화하시겠습니까?')) {
    return;
  }
  
  try {
    isSyncing.value = true;
    
    const response = await axios.post(
      `/api/beneficiary/info/sync/${sisulCode.value}`
    );
    
    if (response.data.success) {
      alert(response.data.message);
      await fetchBeneficiaryInfoList();
    } else {
      alert(response.data.message || '동기화에 실패했습니다.');
    }
  } catch (error) {
    console.error('수급자 동기화 오류:', error);
    alert('수급자 동기화에 실패했습니다.');
  } finally {
    isSyncing.value = false;
  }
};

// 수정 시작
const startEdit = (info: BeneficiaryInfo) => {
  editingPatientCode.value = info.bf_patient_code;
  editForm.value = {
    patientCode: info.bf_patient_code,
    patientName: info.bf_patient_name,
    birth: info.bf_birth || '',
    grade: info.bf_grade || '',
    copayRate: info.bf_copay_rate || '',
    copayType: info.bf_copay_type || '',
    phone: info.bf_phone || '',
    address: info.bf_address || '',
    startDate: info.bf_start_date || '',
    endDate: info.bf_end_date || '',
    memo: info.bf_memo || '',
    status: info.bf_status || 'active'
  };
};

// 수정 취소
const cancelEdit = () => {
  editingPatientCode.value = null;
};

// 생년월일 입력 시 자동 하이픈 포맷팅
const onBirthInput = (event: Event) => {
  const input = event.target as HTMLInputElement;
  let value = input.value.replace(/[^0-9]/g, ''); // 숫자만 추출
  
  // 최대 8자리까지만 허용 (YYYYMMDD)
  if (value.length > 8) {
    value = value.substring(0, 8);
  }
  
  // 하이픈 자동 삽입
  let formatted = '';
  if (value.length > 0) {
    formatted = value.substring(0, 4); // YYYY
    if (value.length > 4) {
      formatted += '-' + value.substring(4, 6); // MM
      if (value.length > 6) {
        formatted += '-' + value.substring(6, 8); // DD
      }
    }
  }
  
  editForm.value.birth = formatted;
  input.value = formatted;
};

// 수정 저장
const saveEdit = async () => {
  if (!sisulCode.value || !editForm.value.patientCode) return;
  
  try {
    isSaving.value = true;
    
    const response = await axios.post(
      `/api/beneficiary/info/${sisulCode.value}`,
      editForm.value
    );
    
    if (response.data.success) {
      alert(response.data.message);
      editingPatientCode.value = null;
      await fetchBeneficiaryInfoList();
    } else {
      alert(response.data.message || '저장에 실패했습니다.');
    }
  } catch (error) {
    console.error('수급자 정보 저장 오류:', error);
    alert('수급자 정보 저장에 실패했습니다.');
  } finally {
    isSaving.value = false;
  }
};

const initializeData = async () => {
  isLoading.value = true;
  
  try {
    await fetchBeneficiaryList();
    await fetchPeriodBeneficiaries();
    // 기본 탭이 수급자 관리이므로 수급자 정보도 로드
    await fetchBeneficiaryInfoList();
  } catch (error) {
    console.error('데이터 초기화 오류:', error);
  } finally {
    isLoading.value = false;
  }
};

// Watchers
watch(sisulCode, () => {
  if (sisulCode.value) {
    initializeData();
  }
});

// 연도나 월이 변경되면 해당 기간 수급자 다시 조회
watch([selectedYear, selectedMonth], () => {
  if (periodMode.value === 'month') {
    fetchPeriodBeneficiaries();
  }
});

// Lifecycle
onMounted(() => {
  if (sisulCode.value) {
    initializeData();
  } else {
    isLoading.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(LodingComponent, {
      "is-visible": isLoading.value,
      text: "데이터 로딩 중..."
    }, null, 8, ["is-visible"]),
    (!isLoading.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["beneficiary-layout", { 'sidebar-right': sidebarPosition.value === 'right' }])
        }, [
          _createElementVNode("aside", _hoisted_2, [
            _createElementVNode("button", {
              class: "sidebar-position-toggle",
              onClick: toggleSidebarPosition,
              title: sidebarPosition.value === 'left' ? '우측으로 이동' : '좌측으로 이동'
            }, [
              _createVNode(_component_v_icon, { size: "14" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(sidebarPosition.value === 'left' ? 'mdi-arrow-right' : 'mdi-arrow-left'), 1)
                ]),
                _: 1
              })
            ], 8, _hoisted_3),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_v_icon, { size: "16" }, {
                default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                  _createTextVNode("mdi-account-heart", -1)
                ]))]),
                _: 1
              }),
              _cache[11] || (_cache[11] = _createElementVNode("span", null, "수급자 관리", -1))
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("button", {
                class: _normalizeClass(["sidebar-tab", { active: activeTab.value === 'manage' }]),
                onClick: _cache[0] || (_cache[0] = ($event: any) => {activeTab.value = 'manage'; fetchBeneficiaryInfoList()})
              }, [
                _createVNode(_component_v_icon, { size: "16" }, {
                  default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                    _createTextVNode("mdi-account-cog", -1)
                  ]))]),
                  _: 1
                }),
                _cache[13] || (_cache[13] = _createElementVNode("span", null, "수급자 관리", -1))
              ], 2),
              _createElementVNode("button", {
                class: _normalizeClass(["sidebar-tab", { active: activeTab.value === 'schedule' }]),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (activeTab.value = 'schedule'))
              }, [
                _createVNode(_component_v_icon, { size: "16" }, {
                  default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                    _createTextVNode("mdi-calendar-account", -1)
                  ]))]),
                  _: 1
                }),
                _cache[15] || (_cache[15] = _createElementVNode("span", null, "일정 목록", -1))
              ], 2)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[16] || (_cache[16] = _createElementVNode("div", { class: "summary-header" }, [
                  _createElementVNode("span", { class: "dot" }),
                  _createElementVNode("span", { class: "label" }, "전체 수급자")
                ], -1)),
                _createElementVNode("span", _hoisted_8, _toDisplayString(beneficiaryList.value.length) + "명", 1)
              ]),
              _cache[19] || (_cache[19] = _createElementVNode("div", { class: "summary-divider" }, null, -1)),
              _createElementVNode("div", _hoisted_9, [
                _cache[17] || (_cache[17] = _createElementVNode("div", { class: "summary-header" }, [
                  _createElementVNode("span", { class: "dot" }),
                  _createElementVNode("span", { class: "label" }, "이번달 수급자")
                ], -1)),
                _createElementVNode("span", _hoisted_10, _toDisplayString(activeThisMonth.value) + "명", 1)
              ]),
              _cache[20] || (_cache[20] = _createElementVNode("div", { class: "summary-divider" }, null, -1)),
              _createElementVNode("div", _hoisted_11, [
                _cache[18] || (_cache[18] = _createElementVNode("div", { class: "summary-header" }, [
                  _createElementVNode("span", { class: "dot" }),
                  _createElementVNode("span", { class: "label" }, "총 서비스 개월")
                ], -1)),
                _createElementVNode("span", _hoisted_12, _toDisplayString(totalServiceMonths.value) + "개월", 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_v_icon, {
                  size: "14",
                  color: "#64748b"
                }, {
                  default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                    _createTextVNode("mdi-magnify", -1)
                  ]))]),
                  _: 1
                }),
                _cache[22] || (_cache[22] = _createElementVNode("span", null, "수급자 검색", -1))
              ]),
              _createElementVNode("div", _hoisted_15, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "search-input",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchKeyword).value = $event)),
                  placeholder: "이름으로 검색..."
                }, null, 512), [
                  [_vModelText, searchKeyword.value]
                ]),
                (searchKeyword.value)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "search-clear",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (searchKeyword.value = ''))
                    }, [
                      _createVNode(_component_v_icon, { size: "12" }, {
                        default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                          _createTextVNode("mdi-close", -1)
                        ]))]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("button", {
                class: _normalizeClass(["period-all-btn", { active: periodMode.value === 'all' }]),
                onClick: _cache[4] || (_cache[4] = ($event: any) => (setPeriodMode('all')))
              }, [
                _createVNode(_component_v_icon, { size: "20" }, {
                  default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                    _createTextVNode("mdi-calendar-multiple", -1)
                  ]))]),
                  _: 1
                }),
                _cache[25] || (_cache[25] = _createElementVNode("span", null, "전체 기간 보기", -1))
              ], 2),
              _createElementVNode("div", _hoisted_17, [
                _cache[30] || (_cache[30] = _createElementVNode("div", { class: "period-month-label" }, "또는 특정 월 선택:", -1)),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("button", {
                    class: "month-nav-btn prev",
                    onClick: prevMonth,
                    disabled: !canGoPrev.value
                  }, [
                    _createVNode(_component_v_icon, { size: "24" }, {
                      default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                        _createTextVNode("mdi-chevron-left", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[27] || (_cache[27] = _createElementVNode("span", null, "이전", -1))
                  ], 8, _hoisted_19),
                  _createElementVNode("button", {
                    class: _normalizeClass(["period-current-month", { active: periodMode.value === 'month' }]),
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (setPeriodMode('month')))
                  }, [
                    _createElementVNode("div", _hoisted_20, _toDisplayString(selectedYear.value) + "년", 1),
                    _createElementVNode("div", _hoisted_21, _toDisplayString(selectedMonth.value) + "월", 1)
                  ], 2),
                  _createElementVNode("button", {
                    class: "month-nav-btn next",
                    onClick: nextMonth,
                    disabled: !canGoNext.value
                  }, [
                    _cache[29] || (_cache[29] = _createElementVNode("span", null, "다음", -1)),
                    _createVNode(_component_v_icon, { size: "24" }, {
                      default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                        _createTextVNode("mdi-chevron-right", -1)
                      ]))]),
                      _: 1
                    })
                  ], 8, _hoisted_22)
                ])
              ])
            ])
          ]),
          _createElementVNode("main", _hoisted_23, [
            (activeTab.value === 'schedule')
              ? (_openBlock(), _createElementBlock("section", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _createVNode(_component_v_icon, {
                          size: "18",
                          color: "white"
                        }, {
                          default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                            _createTextVNode("mdi-calendar-account", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _cache[32] || (_cache[32] = _createElementVNode("span", { class: "title-text" }, "수급자 일정 목록", -1)),
                      _createElementVNode("span", _hoisted_28, _toDisplayString(filteredBeneficiaryList.value.length) + "명", 1),
                      _cache[33] || (_cache[33] = _createElementVNode("span", { class: "title-badge" }, "일정계획 기준", -1))
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("button", {
                        class: "batch-pdf-btn",
                        onClick: printAllPatientsPdf,
                        disabled: isPdfLoading.value || filteredBeneficiaryList.value.length === 0 || periodMode.value === 'all',
                        title: periodMode.value === 'all' ? '특정 월을 선택해주세요' : '전체 수급자 일정표 PDF 출력'
                      }, [
                        _createVNode(_component_v_icon, { size: "18" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(isPdfLoading.value ? 'mdi-loading mdi-spin' : 'mdi-file-pdf-box'), 1)
                          ]),
                          _: 1
                        }),
                        _cache[34] || (_cache[34] = _createElementVNode("span", null, "전체 일정표 출력", -1))
                      ], 8, _hoisted_30),
                      _createElementVNode("span", _hoisted_31, _toDisplayString(displayPeriodLabel.value) + " 기준", 1)
                    ])
                  ]),
                  (filteredBeneficiaryList.value.length > 0)
                    ? (_openBlock(), _createElementBlock("table", _hoisted_32, [
                        _cache[41] || (_cache[41] = _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", { class: "col-no" }, "No"),
                            _createElementVNode("th", null, "수급자명"),
                            _createElementVNode("th", null, "수급자코드"),
                            _createElementVNode("th", { class: "text-center" }, "첫 서비스"),
                            _createElementVNode("th", { class: "text-center" }, "최근 서비스"),
                            _createElementVNode("th", { class: "text-center" }, "총 서비스"),
                            _createElementVNode("th", { class: "text-center col-action" }, "상세보기"),
                            _createElementVNode("th", { class: "text-center col-action" }, "일정표")
                          ])
                        ], -1)),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredBeneficiaryList.value, (beneficiary, index) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: beneficiary.patient_code
                            }, [
                              _createElementVNode("tr", {
                                class: _normalizeClass([{ selected: selectedBeneficiary.value?.patient_code === beneficiary.patient_code }, "beneficiary-row"])
                              }, [
                                _createElementVNode("td", _hoisted_33, _toDisplayString(index + 1), 1),
                                _createElementVNode("td", null, [
                                  _createElementVNode("div", _hoisted_34, [
                                    _createElementVNode("div", _hoisted_35, [
                                      _createVNode(_component_v_icon, { size: "12" }, {
                                        default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                                          _createTextVNode("mdi-account", -1)
                                        ]))]),
                                        _: 1
                                      })
                                    ]),
                                    _createTextVNode(" " + _toDisplayString(beneficiary.patient_name), 1)
                                  ])
                                ]),
                                _createElementVNode("td", null, _toDisplayString(beneficiary.patient_code), 1),
                                _createElementVNode("td", _hoisted_36, [
                                  _createElementVNode("span", _hoisted_37, _toDisplayString(formatDateShort(beneficiary.first_service_date)), 1)
                                ]),
                                _createElementVNode("td", _hoisted_38, [
                                  _createElementVNode("span", _hoisted_39, _toDisplayString(formatDateShort(beneficiary.last_service_date)), 1)
                                ]),
                                _createElementVNode("td", _hoisted_40, [
                                  _createElementVNode("span", _hoisted_41, _toDisplayString(beneficiary.total_months) + "개월", 1)
                                ]),
                                _createElementVNode("td", _hoisted_42, [
                                  _createElementVNode("button", {
                                    class: _normalizeClass(["action-btn detail-btn", { active: selectedBeneficiary.value?.patient_code === beneficiary.patient_code }]),
                                    onClick: ($event: any) => (toggleBeneficiary(beneficiary)),
                                    title: "상세보기"
                                  }, [
                                    _createVNode(_component_v_icon, { size: "16" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(selectedBeneficiary.value?.patient_code === beneficiary.patient_code ? 'mdi-chevron-up' : 'mdi-chevron-down'), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ], 10, _hoisted_43)
                                ]),
                                _createElementVNode("td", _hoisted_44, [
                                  _createElementVNode("button", {
                                    class: "action-btn schedule-btn",
                                    onClick: ($event: any) => (printSchedulePdf(beneficiary)),
                                    title: "일정표 PDF 출력"
                                  }, [
                                    _createVNode(_component_v_icon, { size: "16" }, {
                                      default: _withCtx(() => [...(_cache[36] || (_cache[36] = [
                                        _createTextVNode("mdi-file-pdf-box", -1)
                                      ]))]),
                                      _: 1
                                    })
                                  ], 8, _hoisted_45)
                                ])
                              ], 2),
                              (selectedBeneficiary.value?.patient_code === beneficiary.patient_code)
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_46, [
                                    _createElementVNode("td", _hoisted_47, [
                                      _createElementVNode("div", _hoisted_48, [
                                        (monthlySummary.value.length > 0)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(monthlySummary.value, (month) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                  class: "month-card",
                                                  key: month.year_month
                                                }, [
                                                  _createElementVNode("div", _hoisted_50, [
                                                    _createElementVNode("span", _hoisted_51, _toDisplayString(formatYearMonth(month.year_month)), 1)
                                                  ]),
                                                  _createElementVNode("div", _hoisted_52, [
                                                    _createElementVNode("div", _hoisted_53, [
                                                      _createElementVNode("div", _hoisted_54, _toDisplayString(month.service_days), 1),
                                                      _cache[37] || (_cache[37] = _createElementVNode("div", { class: "stat-label" }, "서비스일", -1))
                                                    ]),
                                                    _createElementVNode("div", _hoisted_55, [
                                                      _createElementVNode("div", _hoisted_56, _toDisplayString(formatMinutes(month.total_minutes)), 1),
                                                      _cache[38] || (_cache[38] = _createElementVNode("div", { class: "stat-label" }, "총 시간", -1))
                                                    ])
                                                  ]),
                                                  (month.caregivers)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                                        _createVNode(_component_v_icon, {
                                                          size: "12",
                                                          class: "mr-1"
                                                        }, {
                                                          default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                                                            _createTextVNode("mdi-account-heart", -1)
                                                          ]))]),
                                                          _: 1
                                                        }),
                                                        _createElementVNode("span", null, _toDisplayString(month.caregivers), 1)
                                                      ]))
                                                    : _createCommentVNode("", true),
                                                  (month.suga_types)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                                        _createVNode(_component_v_icon, {
                                                          size: "12",
                                                          class: "mr-1"
                                                        }, {
                                                          default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
                                                            _createTextVNode("mdi-clipboard-list", -1)
                                                          ]))]),
                                                          _: 1
                                                        }),
                                                        _createElementVNode("span", null, _toDisplayString(month.suga_types), 1)
                                                      ]))
                                                    : _createCommentVNode("", true)
                                                ]))
                                              }), 128))
                                            ]))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_59, "서비스 이력 데이터가 없습니다"))
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 128))
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_60, [
                        _createElementVNode("div", _hoisted_61, [
                          _createVNode(_component_v_icon, { size: "36" }, {
                            default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                              _createTextVNode("mdi-calendar-account-outline", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _cache[43] || (_cache[43] = _createElementVNode("div", { class: "empty-text" }, "일정계획 데이터가 없습니다", -1)),
                        _cache[44] || (_cache[44] = _createElementVNode("div", { class: "empty-hint" }, "일정계획 파일이 업로드되면 수급자 일정이 표시됩니다", -1))
                      ]))
                ]))
              : _createCommentVNode("", true),
            (activeTab.value === 'manage')
              ? (_openBlock(), _createElementBlock("section", _hoisted_62, [
                  _createElementVNode("div", _hoisted_63, [
                    _createElementVNode("div", _hoisted_64, [
                      _createElementVNode("div", _hoisted_65, [
                        _createVNode(_component_v_icon, {
                          size: "18",
                          color: "white"
                        }, {
                          default: _withCtx(() => [...(_cache[45] || (_cache[45] = [
                            _createTextVNode("mdi-account-cog", -1)
                          ]))]),
                          _: 1
                        })
                      ]),
                      _cache[46] || (_cache[46] = _createElementVNode("span", { class: "title-text" }, "수급자 정보 관리", -1)),
                      _createElementVNode("span", _hoisted_66, _toDisplayString(beneficiaryInfoList.value.length) + "명", 1)
                    ]),
                    _createElementVNode("div", _hoisted_67, [
                      _createElementVNode("button", {
                        class: "sync-btn",
                        onClick: syncBeneficiaries,
                        disabled: isSyncing.value,
                        title: "일정계획에서 수급자 동기화"
                      }, [
                        _createVNode(_component_v_icon, { size: "18" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(isSyncing.value ? 'mdi-loading mdi-spin' : 'mdi-sync'), 1)
                          ]),
                          _: 1
                        }),
                        _cache[47] || (_cache[47] = _createElementVNode("span", null, "일정계획에서 동기화", -1))
                      ], 8, _hoisted_68)
                    ])
                  ]),
                  (filteredBeneficiaryInfoList.value.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                        _createElementVNode("table", _hoisted_70, [
                          _cache[51] || (_cache[51] = _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("th", { class: "col-no" }, "No"),
                              _createElementVNode("th", null, "수급자명"),
                              _createElementVNode("th", null, "장기요양인정번호"),
                              _createElementVNode("th", { class: "text-center" }, "생년월일"),
                              _createElementVNode("th", { class: "text-center" }, "등급"),
                              _createElementVNode("th", { class: "text-center" }, "본인부담율"),
                              _createElementVNode("th", { class: "text-center col-action" }, "수정")
                            ])
                          ], -1)),
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredBeneficiaryInfoList.value, (info, index) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: info.bf_patient_code,
                                class: _normalizeClass(["beneficiary-row", { editing: editingPatientCode.value === info.bf_patient_code }])
                              }, [
                                _createElementVNode("td", _hoisted_71, _toDisplayString(index + 1), 1),
                                _createElementVNode("td", null, [
                                  _createElementVNode("div", _hoisted_72, [
                                    _createElementVNode("div", _hoisted_73, [
                                      _createVNode(_component_v_icon, { size: "12" }, {
                                        default: _withCtx(() => [...(_cache[48] || (_cache[48] = [
                                          _createTextVNode("mdi-account", -1)
                                        ]))]),
                                        _: 1
                                      })
                                    ]),
                                    _createTextVNode(" " + _toDisplayString(info.bf_patient_name), 1)
                                  ])
                                ]),
                                _createElementVNode("td", null, _toDisplayString(info.bf_patient_code), 1),
                                _createElementVNode("td", _hoisted_74, [
                                  (editingPatientCode.value !== info.bf_patient_code)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_75, _toDisplayString(info.bf_birth || '-'), 1))
                                    : (_openBlock(), _createElementBlock("input", {
                                        key: 1,
                                        type: "text",
                                        class: "edit-input",
                                        value: editForm.value.birth,
                                        onInput: onBirthInput,
                                        placeholder: "YYYY-MM-DD",
                                        maxlength: "10"
                                      }, null, 40, _hoisted_76))
                                ]),
                                _createElementVNode("td", _hoisted_77, [
                                  (editingPatientCode.value !== info.bf_patient_code)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_78, [
                                        (info.bf_grade)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_79, _toDisplayString(info.bf_grade), 1))
                                          : (_openBlock(), _createElementBlock("span", _hoisted_80, "-"))
                                      ]))
                                    : _withDirectives((_openBlock(), _createElementBlock("input", {
                                        key: 1,
                                        type: "text",
                                        class: "edit-input",
                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((editForm.value.grade) = $event)),
                                        placeholder: "등급 입력",
                                        maxlength: "20"
                                      }, null, 512)), [
                                        [_vModelText, editForm.value.grade]
                                      ])
                                ]),
                                _createElementVNode("td", _hoisted_81, [
                                  (editingPatientCode.value !== info.bf_patient_code)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_82, [
                                        (info.bf_copay_rate)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_83, _toDisplayString(info.bf_copay_rate), 1))
                                          : (_openBlock(), _createElementBlock("span", _hoisted_84, "-"))
                                      ]))
                                    : _withDirectives((_openBlock(), _createElementBlock("input", {
                                        key: 1,
                                        type: "text",
                                        class: "edit-input",
                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((editForm.value.copayRate) = $event)),
                                        placeholder: "본인부담율 입력",
                                        maxlength: "20"
                                      }, null, 512)), [
                                        [_vModelText, editForm.value.copayRate]
                                      ])
                                ]),
                                _createElementVNode("td", _hoisted_85, [
                                  (editingPatientCode.value !== info.bf_patient_code)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        class: "action-btn edit-btn",
                                        onClick: ($event: any) => (startEdit(info)),
                                        title: "수정"
                                      }, [
                                        _createVNode(_component_v_icon, { size: "16" }, {
                                          default: _withCtx(() => [...(_cache[49] || (_cache[49] = [
                                            _createTextVNode("mdi-pencil", -1)
                                          ]))]),
                                          _: 1
                                        })
                                      ], 8, _hoisted_86))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createElementVNode("button", {
                                          class: "action-btn save-btn",
                                          onClick: _cache[8] || (_cache[8] = ($event: any) => (saveEdit())),
                                          disabled: isSaving.value,
                                          title: "저장"
                                        }, [
                                          _createVNode(_component_v_icon, { size: "16" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(isSaving.value ? 'mdi-loading mdi-spin' : 'mdi-check'), 1)
                                            ]),
                                            _: 1
                                          })
                                        ], 8, _hoisted_87),
                                        _createElementVNode("button", {
                                          class: "action-btn cancel-btn",
                                          onClick: _cache[9] || (_cache[9] = ($event: any) => (cancelEdit())),
                                          title: "취소"
                                        }, [
                                          _createVNode(_component_v_icon, { size: "16" }, {
                                            default: _withCtx(() => [...(_cache[50] || (_cache[50] = [
                                              _createTextVNode("mdi-close", -1)
                                            ]))]),
                                            _: 1
                                          })
                                        ])
                                      ], 64))
                                ])
                              ], 2))
                            }), 128))
                          ])
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_88, [
                        _createElementVNode("div", _hoisted_89, [
                          _createVNode(_component_v_icon, { size: "36" }, {
                            default: _withCtx(() => [...(_cache[52] || (_cache[52] = [
                              _createTextVNode("mdi-account-plus-outline", -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _cache[53] || (_cache[53] = _createElementVNode("div", { class: "empty-text" }, "등록된 수급자 정보가 없습니다", -1)),
                        _cache[54] || (_cache[54] = _createElementVNode("div", { class: "empty-hint" }, "\"일정계획에서 동기화\" 버튼을 클릭하여 수급자를 등록하세요", -1))
                      ]))
                ]))
              : _createCommentVNode("", true)
          ])
        ], 2))
      : _createCommentVNode("", true)
  ]))
}
}

})